export const envChannel = (environmentId: number) => `env:${environmentId}`;

const ENTITY_TYPE = /^[a-z_]{1,32}$/;
const ENTITY_ID = /^[A-Za-z0-9_-]{1,64}$/;

/** The channel for one entity (e.g. a Design Studio node), or null when the server would refuse the type or id. */
export function entityChannel(environmentId: number, type: string, id: string): string | null {
  if (!ENTITY_TYPE.test(type) || !ENTITY_ID.test(id)) return null;
  return `env:${environmentId}:entity:${type}:${id}`;
}

/** Entity channels track who is in them; the workspace channel only carries server messages. */
export const wantsJoinLeave = (channel: string) => channel.includes(':entity:');
